import { defineMessages } from 'react-intl';

export default defineMessages({
  removeString: {
    id: 'remove',
    description: 'remove',
    defaultMessage: 'Remove',
  },
});
